
export const WaterIcon: React.FC = () => {
  return (
    <>
      <path
        fill="#bdccd4"
        d="M0 52a34.18 34.18 0 01-34.14-34.14c0-18.94 8.91-36.78 16.39-48.41A135.5 135.5 0 01-1.41-51.41L0-52.83l1.41 1.42a135.5 135.5 0 0116.34 20.86c7.48 11.63 16.39 29.47 16.39 48.41A34.18 34.18 0 010 52zm0-99.09a140.72 140.72 0 00-14.44 18.78c-7.16 11.16-15.7 28.23-15.7 46.17A30.17 30.17 0 000 48a30.17 30.17 0 0030.14-30.14c0-17.94-8.54-35-15.7-46.17A140.72 140.72 0 000-47.09z"
      />
      <path
        fill="#bdccd4"
        d="M9.5 32.5a12 12 0 1112-12 12 12 0 01-12 12zm0-20a8 8 0 108 8 8 8 0 00-8-8z"
      />
      <path
        fill="#bdccd4"
        d="M14.5 12.5a7 7 0 117-7 7 7 0 01-7 7zm0-10a3 3 0 103 3 3 3 0 00-3-3z"
      />
    </>
  );
};
